import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule, inject } from '@angular/core';
import { TRANSLOCO_CONFIG, Translation, TranslocoLoader, TranslocoModule, translocoConfig } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

export const translocoConfigOptions = translocoConfig({
  reRenderOnLangChange: true,
  availableLangs: ['de'],
  defaultLang: 'de',
  prodMode: false,
});

@NgModule({
  imports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfigOptions,
    },
    TranslocoHttpLoader,
  ],
  exports: [TranslocoModule],
})
export class QiraTranslocoModule {}
